export type Brand = {
  id: string;
  name: string;
  slug: string;
  logoPath?: string | null;
  badgeLogoPath?: string | null;
  description?: string | null;
  sortOrder?: number;
  isActive?: boolean;
  productCount?: number;
};

export async function fetchBrands(): Promise<Brand[]> {
  const response = await fetch(`${import.meta.env.VITE_API_URL}/api/products/brands`);
  if (!response.ok) {
    throw new Error('Failed to fetch brands');
  }

  return response.json();
}
